module.exports = __webpack_public_path__ + "img/shipo-menu-settings.7b8af906.svg";